import {Modal, TextField, Toast} from "@shopify/polaris";
import React, {useState } from "react";
import intl from "../../../../../../i18n/intl";
import { reqGetOptimizeProductTitle, reqPostOptimizeProductTitleSave } from "../../../../../../api";

const OperationModal = ({chatData,setChatData}) => {
    const [doneBtnLoading, setDoneBtnLoading] = useState(false);

    const handleChangeTitle = (value)=>{
        setChatData((prevValue)=>({
            ...prevValue,
            title:value
        }))
    };
    // 确定
    const handleSave = async ()=>{
        setDoneBtnLoading(true)
        try {
            let params = {
                user_product_id:chatData.user_product_id,
                title:chatData.title
            }
            if (params.user_product_id === '' || params.title === chatData.oldTitle) {
              setDoneBtnLoading(false)
              handleDiscard();
                return
            }
            let res = await reqPostOptimizeProductTitleSave(params);
            if (res.code === '200') {
                chatData.titleFc({Title:chatData.title})
                handleDiscard()
                toggleToast2(intl.get('Saved successfully'))
            }else{
              toggleToast2(res.msg)
            }
            setDoneBtnLoading(false)
        } catch (error) {
        }
       
    }
    const [loading,setLoading] = useState(false);
    const handleChatTitle = async()=>{
      try {
      let params = {
        title:chatData.oldTitle
      }
      setLoading(true)
      let res = await reqGetOptimizeProductTitle(params);
      if (res.code === '200') {
        setChatData((prevValue)=>({
          ...prevValue,
          title:res.data.optimized_title
        }))
        toggleToast('Optimization completed')
      }else {
        toggleToast(res.msg)
      }
      setLoading(false)
    } catch (error) {
        
    }
    }
    // 取消
    const handleDiscard = ()=>{
        setChatData((prevValue)=>({
            ...prevValue,
            title:'',
            titleOpen:false
        }));
        setLoading(false)
        setDoneBtnLoading(false)
    }
    const [showToast2, setShowToast2] = useState(false);
    const [showToastText2, setShowToastText2] = useState("");
    const [showToastIserror2, setShowToastIserror2] = useState(false);
     //提示弹窗
     const toggleToast2 = (showToastText, showToastIserror = false) => {
        setShowToast2(!showToast2);
        setShowToastText2(showToastText);
        setShowToastIserror2(showToastIserror);
      };
  
      
    const [showToast, setShowToast] = useState(false);
    const [showToastText, setShowToastText] = useState("");
    const [showToastIserror, setShowToastIserror] = useState(false);
     //提示弹窗
     const toggleToast = (showToastText, showToastIserror = false) => {
        setShowToast(!showToast);
        setShowToastText(showToastText);
        setShowToastIserror(showToastIserror);
      };
  
      const toastMarkup = showToast && chatData.titleOpen ? (
        <Toast
          content={showToastText}
          onDismiss={() => toggleToast("")}
          error={showToastIserror}
        />
      ) : null;
      const toastMarkup2 = showToast2 ? (
        <Toast
          content={showToastText2}
          onDismiss={() => toggleToast2("")}
          error={showToastIserror2}
        />
      ) : null;
  return (
    <>
      <Modal
        size="large"
        open={chatData.titleOpen}
        title={intl.get('AI Title Optimization')}
        onClose={()=>handleDiscard()}
        primaryAction={{
          content: intl.get("Save"),
          onAction: () => handleSave(),
          loading:doneBtnLoading
        }}
        secondaryActions={[
          {
            content: intl.get("Discard"),
            onAction: () => handleDiscard(),
          },
        ]}
      >
        <Modal.Section>
            <div className="chat_gpt_modal">
                <div className="chat_gpt_modal_item">
            <TextField
                label={intl.get("Original Title")}
                value={chatData.oldTitle}
                disabled
                onChange={()=>console.log()}
                autoComplete="off"
                />
                <span className="chat_gpt_modal_item_span"></span>
                </div>
                <div className="chat_gpt_modal_item">
            <TextField
                minLength={10}
                maxLength={100}
                label={intl.get("Optimized Title")}
                value={chatData.title}
                multiline={'auto'}
                onChange={handleChangeTitle}
                autoComplete="off"
                />
                {loading ? <span className="chat_gpt_modal_item_spans">
                <img src="/chatgpt_again.png" alt="dropshipman" />
                 </span> : <span className="chat_gpt_modal_item_span " onClick={()=>handleChatTitle()}>
                <img src="/chatgpt_again.png" alt="dropshipman" />
                 </span>}
                </div>
            </div>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {toastMarkup2}
    </>
  );
};

export default OperationModal;
